import { render, staticRenderFns } from "./ContestInGroup.vue?vue&type=template&id=6df523bf&scoped=true&"
import script from "./ContestInGroup.vue?vue&type=script&lang=js&"
export * from "./ContestInGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df523bf",
  null
  
)

export default component.exports